.root {
  &.isRelative {
    position: relative;
  }

  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  padding: var(--theme--tokens--card--padding);
  padding-bottom: 0;
}